import Vue from 'vue';
import Router from 'vue-router';
import { publicRoute } from './config';
import { use_is_single_site_store } from '@/stores/is_single_site';
import pinia from '@/stores';

// const routes = publicRoute.concat(protectedRoute);

Vue.use(Router);
const router = new Router({
  // mode: 'hash',
  mode: 'history',
  // linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: publicRoute,
});

router.beforeEach((to, from, next) => {
  use_is_single_site_store(pinia)?.set_is_single_site(to?.meta?.is_single_site || false);
  next();
});

export default router;
